export const supplierIntegrationUrl = {
    PRODUCTION: 'https://supplierintegrations.cimpress.io',
    STAGING: 'https://int.supplierintegrations.cimpress.io'
};
export var ServiceName;
(function (ServiceName) {
    ServiceName["SupplierIntegration"] = "supplierIntegration";
    ServiceName["MerchantService"] = "merchantService";
})(ServiceName || (ServiceName = {}));
export const getEnvBasedUrl = (serviceName, env) => {
    if (env === 'int') {
        switch (serviceName) {
            case ServiceName.MerchantService:
                return 'https://int-merchant-config.commerce.cimpress.io';
            case ServiceName.SupplierIntegration:
                return supplierIntegrationUrl.STAGING;
            default:
                return null;
        }
    }
    else {
        switch (serviceName) {
            case ServiceName.MerchantService:
                return 'https://merchant-config.commerce.cimpress.io';
            case ServiceName.SupplierIntegration:
                return supplierIntegrationUrl.PRODUCTION;
            default:
                return null;
        }
    }
};
